export enum SearchQueryKeys {
  GET_APPLICATION_SEARCH_RESULTS = 'GET_APPLICATION_SEARCH_RESULTS',
  GET_FULL_APPLICATION_SEARCH_RESULTS = 'GET_FULL_APPLICATION_SEARCH_RESULTS',
  GET_RECENT_SEARCH = 'GET_RECENT_SEARCH',
  GET_AI_CHAT_HISTORY = 'GET_AI_CHAT_HISTORY',
  AUTHOR_SEARCH = 'AUTHOR_SEARCH',
}

export const AI_SEARCH_SUGGESTIONS = [
  'What are the latest features in the Protocol Labs Directory',
  'How does the Husky AI work within the Protocol Labs Directory',
  'What types of AI projects are being funded by Protocol Labs',
];
